import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccionesDialog } from '@models/base/identificadores.model';
import { GrupoTipoGarantiaInquilinoDto } from '@models/grupos-tipo-garantia-inquilino/grupoTipoGarantiaInquilinoDto.model';
import { GrupoTipoGarantiaDto } from '@models/grupos-tipo-garantia/grupoTipoGarantiaDto.model';
import { GruposTipoGarantiaInquilinoService } from '@services/grupos-tipo-garantia-inquilino/grupos-tipo-garantia-inquilino.service';
import { GruposTipoGarantiaService } from '@services/grupos-tipo-garantia/grupos-tipo-garantia.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { isFalsy } from 'utility-types';
import { DialogGruposTipoGarantiaInquilinoComponent } from '../dialog-grupos-tipo-garantia-inquilino/dialog-grupos-tipo-garantia-inquilino.component';
import { PersonasService } from '@services/personas/personas.service';
import { Router } from '@angular/router';
import { InquilinosService } from '@services/inquilinos/inquilinos.service';

@Component({
  selector: 'app-grupos-tipo-garantia-inquilino',
  templateUrl: './grupos-tipo-garantia-inquilino.component.html',
  styleUrls: ['./grupos-tipo-garantia-inquilino.component.css']
})
export class GruposTipoGarantiaInquilinoComponent implements OnInit {

  data = false
  dataSource = new MatTableDataSource<GrupoTipoGarantiaInquilinoDto>();
  obj!: undefined
  displayedColumns: string[] = ['inquilino', 'grupoTipoGarantia', 'idGrupo', 'accion'];
  detalle!: string;

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }


  constructor(
    public dialog: MatDialog,
    private gruposTipoGarantiaInquilinoService: GruposTipoGarantiaInquilinoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private personasService: PersonasService,
    private router: Router,
    private inquilinosService: InquilinosService
  ) { }


  ngOnInit() {
    this.getAllGruposTiposGarantiaInquilino();
    this.dataSource.filterPredicate = function (data: GrupoTipoGarantiaInquilinoDto, filter: string): boolean {
      return data.inquilino.persona.descripcion.toLowerCase().includes(filter);
    };



  }

  applyFilter(event: any) {
    if (event && event.target && event.target.value !== undefined) {
const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
}
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAllGruposTiposGarantiaInquilino() {
    this.spinner.show()
    this.gruposTipoGarantiaInquilinoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.snackBar.showError(error, "Error");
          this.spinner.hide()
        }
      )
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = obj
    dialogConfig.width = "35%"

    const dialogRef = this.dialog.open(DialogGruposTipoGarantiaInquilinoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event != AccionesDialog.Cancelar)
      {
        this.getAllGruposTiposGarantiaInquilino()
      }

    });
  }

  editarPersona(persona: any) {
    this.getPersonaById(persona.id)
  }

  getPersonaById(idPersona: number) {
    this.spinner.show()
    this.personasService.getPersonaById(idPersona)
      .subscribe(
        data => {
          this.spinner.hide()
          this.personasService.setPersona(data)
          this.router.navigate(["/personas/editar"])
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        });
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
